import React from 'react';
import { at } from 'lodash';
import { useField, useFormikContext } from 'formik';
import { Autocomplete, TextField } from '@mui/material';
import { boolean } from 'yup';

function AutocompleteMultiple(props: any) {
  const { label, options, onChange, element, renderOption, renderTags, ...rest } = props;
  const formikProps = useFormikContext();
  const [field, meta] = useField(props);

  const selectedValue = field.value || [];
  const [touched, error] = at(meta, 'touched', 'error');

  function _renderHelperText() {
    if (touched && error) {
      return error;
    }
  }

  return (
    <Autocomplete
      multiple
      disablePortal
      filterSelectedOptions
      isOptionEqualToValue={(option, value) => option.value === value.value}
      options={options}
      getOptionLabel={(option: any) => {
        if (typeof option === 'string') return option;
        if (option && typeof option === 'object' && option.label) return option.label;
        return '';
      }}
      loading={true}
      loadingText="Cargando..."
      onBlur={() => formikProps.setFieldTouched(field.name)}
      onChange={(e, v) => {
        formikProps.setFieldValue(field.name, v); // Guarda en Formik
        if (typeof onChange === 'function') {
          onChange(e, v); // Llama al callback externo
        }
      }}
      value={Array.isArray(selectedValue) ? selectedValue : []}
      renderOption={renderOption || ((props, option: any) => (
        <li {...props} key={option?.value || option?.label || String(option)}>
          {typeof option === 'string' ? option : option.label}
        </li>
      ))}
      renderTags={renderTags}
      renderInput={(params) => (
        <TextField
          {...params}
          {...rest}
          label={label}
          helperText={_renderHelperText()}
          error={Boolean(touched && error)}
        />
      )}
    />
  );
}

AutocompleteMultiple.defaultProps = {
  options: [],
  name: '',
  label: '',
  setValue: '',
  element: '',
  isdisabled: boolean,
  onChange: () => {},
};

export default AutocompleteMultiple;
